const setupSearch = () => {
  const intervalTime = 100; // milliseconds

  let productResults = [];
  let contentResults = [];
  let intervalId = 0;
  let query = '';

  const clearProductResults = () => {
    const productCount = document.getElementById('product-results-count');
    const productList = document.getElementById('product-results-list');

    productCount.style.display = 'none';
    productList.style.display = 'none';

    productResults = [];
  };

  const clearContentResults = () => {
    const contentCount = document.getElementById('content-results-count');
    const contentList = document.getElementById('content-results-list');

    contentCount.style.display = 'none';
    contentList.style.display = 'none';

    contentResults = [];
  };

  const newResults = (results, currentResults) => {
    if (results.length === 0 && currentResults.length === 0) {
      return false;
    }

    let newItems = false;
    if (results.length === currentResults.length) {
      for (let i = 0; i < results.length; i++) { // eslint-disable-line
        if (results[i].Text !== currentResults[i].Text) {
          newItems = true;
        }
      }
    }

    return newItems || results.length !== currentResults.length;
  };

  const handleProductResults = (results) => {
    if (results.length === 0) {
      clearProductResults();
      return;
    }

    if (!newResults(results, productResults)) {
      return;
    }

    const count = document.getElementById('product-results-count');
    const list = document.getElementById('product-results-list');

    count.innerText = '';
    list.innerText = '';
    count.style.display = 'block';
    list.style.display = 'flex';

    const countSpan = document.createElement('span');
    countSpan.innerText = `(${results.length})`;

    count.innerText = 'Products ';
    count.appendChild(countSpan);

    const createListItem = (r) => {
      const name = document.createElement('span');
      name.classList.add('product-name', 'pt-2', 'pb-3');
      name.innerText = r.Text;

      // TODO - Phase 2
      // const cost = document.createElement('span');
      // cost.innerText = '$71.00';

      // const costPrefix = document.createElement('span');
      // costPrefix.classList.add('product-pricing');
      // costPrefix.innerText = 'Starting at ';
      // costPrefix.appendChild(cost);

      const productWrap = document.createElement('span');
      productWrap.classList.add('product-wrap');
      productWrap.appendChild(name);
      // TODO - Phase 2
      // productWrap.appendChild(costPrefix);

      const img = document.createElement('img');
      img.src = r.ImageUrl;
      img.alt = `Image representing ${r.Text}`;

      const a = document.createElement('a');
      a.classList.add('nav-link');
      a.href = r.Url;
      a.appendChild(img);
      a.appendChild(productWrap);

      const li = document.createElement('li');
      li.classList.add('nav-search-list-item');
      li.setAttribute('role', 'menuitem');
      li.appendChild(a);

      return li;
    };

    results.forEach((r) => {
      const listItem = createListItem(r);
      list.appendChild(listItem);
    });

    productResults = results;
  };

  const handleContentResults = (results) => {
    if (results.length === 0) {
      clearContentResults();
      return;
    }

    if (!newResults(results, contentResults)) {
      return;
    }

    const count = document.getElementById('content-results-count');
    const list = document.getElementById('content-results-list');

    count.innerText = '';
    list.innerText = '';
    count.style.display = 'block';
    list.style.display = 'block';

    const countSpan = document.createElement('span');
    countSpan.innerText = `(${results.length})`;

    count.innerText = 'Content ';
    count.appendChild(countSpan);

    const createListItem = (r) => {
      const a = document.createElement('a');
      a.classList.add('nav-link');
      a.href = r.Url;
      a.innerText = r.Text;

      const li = document.createElement('li');
      li.classList.add('nav-search-list-item');
      li.setAttribute('role', 'menuitem');
      li.appendChild(a);

      return li;
    };

    results.forEach((r) => {
      const listItem = createListItem(r);
      list.appendChild(listItem);
    });

    contentResults = results;
  };

  const handleSearchResults = (response) => {
    const container = document.getElementById('results-container');
    if (!container) {
      return;
    }

    const resultsAvailable = response.ProductResults.length > 0 || response.ContentResults.length > 0;
    if (resultsAvailable) {
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
    }

    handleProductResults(response.ProductResults);
    handleContentResults(response.ContentResults);
  };

  const search = () => {
    const input = document.getElementById('search-input');
    if (input.value.length < 3) {
      const container = document.getElementById('results-container');
      const productCount = document.getElementById('product-results-count');
      const productList = document.getElementById('product-results-list');
      const contentCount = document.getElementById('content-results-count');
      const contentList = document.getElementById('content-results-list');

      productCount.style.display = 'none';
      productList.style.display = 'none';
      contentCount.style.display = 'none';
      contentList.style.display = 'none';
      container.style.display = 'none';

      productResults = [];
      contentResults = [];
      return;
    }

    if (input.value === query) {
      return;
    }

    query = input.value;

    const url = `${window.location.protocol}//${window.location.hostname}/api/v1/search`;
    fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ Words: query.split(' ').filter(w => w.length >= 3) }),
    }).then(r => r.json()).then(d => handleSearchResults(d));
  };

  const handleInputOnFocus = () => {
    intervalId = window.setInterval(search, intervalTime);
  };

  const handleInputOnBlur = () => {
    window.clearInterval(intervalId);
    intervalId = 0;
  };

  const setupInputEventHandlers = () => {
    const input = document.getElementById('search-input');
    if (!input) {
      return;
    }

    input.onfocus = handleInputOnFocus;
    input.onblur = handleInputOnBlur;
  };

  setupInputEventHandlers();
};

setupSearch();
